import { Box, Divider, Stack } from "@mui/material";
import { useSSTheme } from "../hooks/useSSTheme";
import { LogoImage } from "./LogoImage";
import { SSText } from "src/components/base/components/SSText";
import { useTeamConfig } from "./TeamConfigProvider";
import React from "react";

export function Footer() {
  const { TEAM_GLOBAL_SETTINGS, IMAGES } = useTeamConfig();
  const theme = useSSTheme();
  const TeamFooterLinks = TEAM_GLOBAL_SETTINGS?.FOOTER?.LINKS;

  return (
    <Stack
      p={2}
      py={6}
      bgcolor={
        TEAM_GLOBAL_SETTINGS?.FOOTER?.BACKGROUND_COLOR ||
        theme.colors.teamSecondary
      }
    >
      <Stack width={"100%"} justifyContent={"center"} alignItems={"center"}>
        <LogoImage src={IMAGES?.FOOTER_LOGO_URL || IMAGES?.LOGO_URL} />
      </Stack>

      <Stack alignItems={"center"} spacing={1} mt={4}>
        {TeamFooterLinks ? (
          <TeamFooterLinks />
        ) : (
          <>
            <SSText
              variant="body"
              onClick={() => {
                window.open("https://www.attend.tech/terms-of-use", "_blank");
              }}
              sx={{
                cursor: "pointer",
                color: theme.colors.common.white,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }}
            >
              Terms & Conditions
            </SSText>
            <SSText
              variant="body"
              onClick={() => {
                window.open("https://www.attend.tech/privacy-policy", "_blank");
              }}
              sx={{
                cursor: "pointer",
                color: theme.colors.common.white,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }}
            >
              Privacy Policy
            </SSText>
          </>
        )}
      </Stack>

      <Box py={4}>
        <Divider color={theme.colors.background.white} />
      </Box>
      <Box textAlign={"center"} pb={6}>
        <SSText color={theme.colors.background.white}>
          {TEAM_GLOBAL_SETTINGS?.FOOTER?.COPYRIGHT_TEXT || (
            <>
              {new Date().getFullYear()} &copy;{" "}
              <span
                onClick={() => window.open("https://attend.tech", "_blank")}
                style={{
                  cursor: "pointer",
                  color: theme.colors.common.white,
                  textDecoration: "underline",
                  textUnderlineOffset: "4px",
                }}
              >
                Attend
              </span>
            </>
          )}
        </SSText>
      </Box>
    </Stack>
  );
}
